import { getAllVisitActivityLogs } from '@crm/services.api';
import { Empty, Timeline } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const OfficeVisitActivityLog = ({ id, initialData }: any) => {
  const [activitiesList, setActivitiesList] = useState<[]>([]);

  useEffect(() => {
    const getActivities = async () => {
      const res = await getAllVisitActivityLogs(id);
      setActivitiesList(res?.data?.data);
    };
    if (id) {
      getActivities();
    }
  }, [id, initialData.assignee_id, initialData.session_notes]);

  if (activitiesList && activitiesList?.length <= 0) {
    return (
      <div className="full-height-activities-content ">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </div>
    );
  }

  return (
    <div className="margin-top-1">
      <Timeline>
        {activitiesList
          .filter((item: any) => item.action_type !== 'created')
          .map((item: any) => {
            return (
              <Timeline.Item key={item?.id}>
                <OfficeVisitActivityItem activities={item} key={item?.id} />
              </Timeline.Item>
            );
          })}
      </Timeline>
    </div>
  );
};

export { OfficeVisitActivityLog };

interface IOfficeVisitActivitiesItem {
  activities?: any;
  key?: any;
}

const OfficeVisitActivityItem = (props: IOfficeVisitActivitiesItem) => {
  const { activities } = props;
  const { activity, action_type, created_at, user } = activities;

  const user_name = user?.first_name + ' ' + user?.last_name;

  const getInformation = (): string | any => {
    if (action_type === 'started' && activity === 'office visit') {
      return (
        <>
          The session has been started{' '}
          <div className="ant-comment-content-author-name time-weight-size">
            by {user_name}, {moment().from(moment(created_at), true)} ago
          </div>
        </>
      );
    } else if (action_type === 'completed' && activity === 'office visit') {
      return (
        <>
          The session has been completed{' '}
          <div className="ant-comment-content-author-name time-weight-size">
            by {user_name}, {moment().from(moment(created_at), true)} ago
          </div>
        </>
      );
    } else if (action_type === 'updated' && activity === 'assignee') {
      return (
        <>
          Assignee has been updated{' '}
          <div className="ant-comment-content-author-name time-weight-size">
            by {user_name}, {moment().from(moment(created_at), true)} ago
          </div>
        </>
      );
    } else if (action_type === 'updated' && activity === 'session note') {
      return (
        <>
          Session notes have been updated{' '}
          <div className="ant-comment-content-author-name time-weight-size">
            by {user_name}, {moment().from(moment(created_at), true)} ago
          </div>
        </>
      );
    }
  };

  return (
    <div>
      <h4 className="margin-0">{getInformation()}</h4>
    </div>
  );
};
